import { ModuleWithProviders, NgModule } from '@angular/core';
import { AccessCodeAddDispatcher } from '@spaq/core/dispatchers/access-code-add-dispatcher';
import { AccessCodeDetailsDispatcher } from '@spaq/core/dispatchers/access-code-details-dispatcher';
import { AccessCodeDispatcher } from '@spaq/core/dispatchers/access-code-dispatcher';
import {
	ACCESS_CODE_ADD_DISPATCHER,
	ACCESS_CODE_ADD_STORE,
	ACCESS_CODE_DETAILS_DISPATCHER,
	ACCESS_CODE_DETAILS_STORE,
	ACCESS_CODE_DISPATCHER,
	ACCESS_CODE_STORE
} from '@spaq/injection';
import { FaqComponent } from '@spaq/modules/faq/faq.component';
import { FaqViewPageComponent } from '@spaq/modules/faq/pages/faq-view-page.component';
import { SharedCommonModule } from '@spaq/shared/shared-common.module';
import { SharedComponentsModule } from '@spaq/shared/shared-components.module';
import { AccessCodeAddStore } from '@spaq/core/stores/access-code-add-store';
import { AccessCodeDetailsStore } from '@spaq/core/stores/access-code-details-store';
import { AccessCodeStore } from '@spaq/core/stores/access-code-store';
import { FaqFooterComponent, FaqHeaderComponent, FaqItemComponent, FaqListComponent, FaqPageComponent } from './components';
import {
	FooterTemplateDirective,
	HeaderTemplateDirective,
	ItemsDirective,
	ItemTemplateDirective,
	ListTemplateDirective,
	NoDataDirective,
	TemplateContextDirective
} from './templates';

@NgModule({
	imports: [SharedCommonModule, SharedComponentsModule],
	declarations: [
		FaqPageComponent,
		FaqListComponent,
		FaqItemComponent,
		FaqHeaderComponent,
		FaqFooterComponent,
		HeaderTemplateDirective,
		FooterTemplateDirective,
		ItemTemplateDirective,
		TemplateContextDirective,
		NoDataDirective,
		FaqViewPageComponent,
		ItemsDirective,
		ListTemplateDirective,
		FaqComponent
	],
	exports: [
		FaqPageComponent,
		FaqListComponent,
		FaqItemComponent,
		FaqHeaderComponent,
		ItemTemplateDirective,
		FaqFooterComponent,
		HeaderTemplateDirective,
		FooterTemplateDirective,
		ListTemplateDirective,
		FaqViewPageComponent
	],
	entryComponents: []
})
export class FaqModule {
	static forRoot(): ModuleWithProviders<FaqModule> {
		return {
			ngModule: FaqModule,
			providers: [
				{ provide: ACCESS_CODE_DISPATCHER, useClass: AccessCodeDispatcher },
				{ provide: ACCESS_CODE_ADD_DISPATCHER, useClass: AccessCodeAddDispatcher },
				{ provide: ACCESS_CODE_DETAILS_DISPATCHER, useClass: AccessCodeDetailsDispatcher },
				{ provide: ACCESS_CODE_STORE, useClass: AccessCodeStore },
				{ provide: ACCESS_CODE_ADD_STORE, useClass: AccessCodeAddStore },
				{ provide: ACCESS_CODE_DETAILS_STORE, useClass: AccessCodeDetailsStore }
			]
		};
	}
}
